export default __webpack_public_path__ + "static/media/ceramol-iage-result-protettiva-disarrossante.68a5effb.png";